import React from "react";
import { Box, Typography, } from "@mui/material";
import BannerImage from "../Asset/Images/BannerImage.png";
import theme from "../theme";

const Banner = () => {

  return (
    <Box sx={{ px: 2, display:'flex', justifyContent:'center', flexDirection:'column', alignItems:'center' }}>
      <Box
        sx={{
          backgroundImage: `url(${BannerImage.src || BannerImage})`,
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "top", // ✅ focus on top of image
          minHeight: "80vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          borderRadius: "1rem",
          overflow: "hidden", // Optional: ensures clean cropping
          maxWidth:"1600px",
          width:'100%'
        }}
      >
        <Typography
          variant="h2"
          sx={{
            fontWeight: 500,
            fontFamily: theme.fonts.secondary,
            color: theme.palette.background.paper,
            fontSize:{xs:'1.5rem', sm:'2rem', md:'3rem'}
          }}
          gutterBottom
        >
          THE WELLNESS VC
        </Typography>
      </Box>
      <Typography
        variant="h6"
        sx={{
          fontWeight: 500,
          // fontFamily: theme.fonts.secondary,
          color: "#1D4979",  
          textAlign:'center',
          my:2
        }}
        gutterBottom
      >
        Supercharging scalable wellness innovations. Supporting purpose led founders. Setting startups up for success.
      </Typography>
    </Box>
  );
};

export default Banner;
